module.exports = __webpack_public_path__ + "img/Martin.f1e7198a.jpg";